"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZActivityFeedItemResponse = exports.ZActivityFeedItemSelect = void 0;
const zodSchemas_generated_1 = require("../generated/zodSchemas.generated");
const types_1 = require("@daymade/common-lib/types");
const zod_1 = require("zod");
exports.ZActivityFeedItemSelect = zodSchemas_generated_1.zodSelectActivityFeedItem.extend((0, types_1.ensureSubsetOfKeys)(zodSchemas_generated_1.zodSelectActivityFeedItem.shape, {
    createdAt: zod_1.z.coerce.date(),
    lastModified: zod_1.z.coerce.date(),
    placeholderData: zod_1.z
        .record(zod_1.z.string(), zod_1.z.object({
        value: zod_1.z.union([zod_1.z.string(), zod_1.z.number()]).nullable(),
        important: zod_1.z.boolean(),
        redirectUrl: zod_1.z.string().nullable().optional(),
        showIfNull: zod_1.z.boolean().optional(),
    }))
        .nullable(),
}));
exports.ZActivityFeedItemResponse = zodSchemas_generated_1.zodSelectActivityFeedItem
    .pick({
    id: true,
    placeholderData: true,
})
    .extend({
    iconUrl: zod_1.z.string().nullable(),
    initials: zod_1.z.string(),
    text: zod_1.z.string(),
    timestamp: zod_1.z.coerce.date(),
})
    .array();
//# sourceMappingURL=models.js.map